import * as React from 'react';
import { confirmAlert } from '../../services/mini/alanConfirmAlert';
import { race, take } from 'redux-saga/effects';
import * as types from './actionTypes.confirm';
import store from '../../store';
import ConfirmPopup from '../../views/components/ConfirmPopup/ConfirmPopup';
import * as errorSaga from '../errors/saga.errors';

export function* confirm(confirmPopupProps) {
    try {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <ConfirmPopup
                        onClose={() => {
                            onClose();
                            store.dispatch({ type: types.CANCEL_BTN_ACTION });
                        }}
                        midBtnCb={() => {
                            onClose();
                            store.dispatch({ type: types.MID_BTN_ACTION });
                        }}
                        okBtnCb={() => {
                            onClose();
                            store.dispatch({ type: types.OK_BTN_ACTION });
                        }}
                        {...confirmPopupProps}
                    />
                );
            }
        });

        return yield race({
            okBtnAction: take(types.OK_BTN_ACTION),
            midBtnAction: take(types.MID_BTN_ACTION),
            cancelBtnAction: take(types.CANCEL_BTN_ACTION)
        });
    } catch (error) {
        yield errorSaga.putError(error);
    }
}